export default __webpack_public_path__ + "static/media/menuIcon.f71c5377.svg";